import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationInstructionsComponent } from './component/transport-registration-instructions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule, ApplicationClientCommonModule, DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRegistrationInstructionsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TransportRegistrationInstructionsModule { }
